module.exports = __webpack_public_path__ + "img/laswerkpijpleiding1.b53595c4.jpg";